/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 $(document).on('click','.product-form .rating-stars-and-text', function () {
  $('html, body').animate({
    scrollTop: $(".custom-review-slider").offset().top - 120
}, 1000);
  });
  document.addEventListener('DOMContentLoaded', function () {

  // Update price function
  function updatePrice(container) {
    let totalPrice = 0;
    let totalMainPrice = 0;

    const selects = container.querySelectorAll('select[data-product-price]');

    selects.forEach((select) => {
      const selectedOption = select.options[select.selectedIndex];

      const price = parseFloat(selectedOption.getAttribute('price')) || 0;
      const mainPrice = parseFloat(selectedOption.getAttribute('price-main')) || 0;

      select.setAttribute('data-product-price', price);
      select.setAttribute('data-product-main-price', mainPrice);

      totalPrice += price;
      totalMainPrice += mainPrice;
    });

    // TOVARA 2026-08-25 (Mail-Sale KW35): Kachel mit data-tov-offer="zweitbrett50"
    // zeigt Summe minus 50% des guenstigsten gewaehlten Bretts - identisch zum
    // Automatic BxGy "Brett Zweitbrett -50% (Mail KW35)", der immer das guenstigste
    // entitled Item rabattiert. Shopify rundet den halben Cent AB (round half down,
    // per draftOrderCalculate verifiziert: 39,95 -> 19,97 / 44,95 -> 22,47 /
    // 59,95 -> 29,97); Math.ceil(x - 0.5) bildet genau das ab.
    // Diese Funktion laeuft als delegierter document-Listener NACH dem Inline-Listener
    // in product-form.liquid und wuerde dessen Ergebnis sonst ueberschreiben.
    if (container.getAttribute('data-tov-offer') === 'zweitbrett50') {
      const tovZbMains = [];
      selects.forEach((sel) => {
        const o = sel.options[sel.selectedIndex];
        tovZbMains.push(parseFloat(o.getAttribute('price-main')) || 0);
      });
      if (tovZbMains.length > 1) {
        totalPrice = totalMainPrice - Math.ceil(Math.min.apply(null, tovZbMains) / 2 - 0.5);
      }
    }

    // TOVARA 2026-08-27 (Fix Kachelpreis 2+1): Kachel mit data-tov-offer="2plus1"
    // zeigt Summe der gewaehlten Pfannen minus die guenstigste (100% gratis) -
    // deckungsgleich mit dem Automatic BxGy "Pfanne 2+1 GRATIS (Ad-Test)", der
    // immer das guenstigste entitled Item gratis macht. Ohne diesen Zweig
    // ueberschreibt diese Funktion (delegierter document-Listener, feuert NACH
    // dem Inline-Listener aus product-form.liquid) den korrekten Kachelpreis beim
    // ersten Groessenwechsel mit der vollen Summe. Rechenregel identisch zu inline.
    if (container.getAttribute('data-tov-offer') === '2plus1') {
      const tov2p1Mains = [];
      selects.forEach((sel) => {
        const o = sel.options[sel.selectedIndex];
        tov2p1Mains.push(parseFloat(o.getAttribute('price-main')) || 0);
      });
      if (tov2p1Mains.length > 1) {
        totalPrice = totalMainPrice - Math.min.apply(null, tov2p1Mains);
      }
    }

    // TOVARA 2026-08-27 (Tier 3 "Bestelle 2, Bekomme 2 mit 50% Rabatt"): Kachel mit
    // data-tov-offer="zweitbrett50x2" zeigt Summe der vier gewaehlten Bretter minus
    // 50% der ZWEI guenstigsten - deckungsgleich mit dem Automatic BxGy
    // "Brett Zweitbrett -50% (Mail KW35)", dessen usesPerOrderLimit dafuer von 1 auf 2
    // erhoeht wurde. Jeder der beiden Nachlaesse wird EINZELN abgerundet (round half
    // down): 2 x 19,97 = 39,94, nicht 39,95. Math.ceil(x - 0.5) bildet genau das ab.
    // Per draftOrderCalculate am 27.08. an 19 Kombinationen verifiziert.
    if (container.getAttribute('data-tov-offer') === 'zweitbrett50x2') {
      const tovZb2Mains = [];
      selects.forEach((sel) => {
        const o = sel.options[sel.selectedIndex];
        tovZb2Mains.push(parseFloat(o.getAttribute('price-main')) || 0);
      });
      if (tovZb2Mains.length > 3) {
        tovZb2Mains.sort((a, b) => a - b);
        totalPrice = totalMainPrice
          - Math.ceil(tovZb2Mains[0] / 2 - 0.5)
          - Math.ceil(tovZb2Mains[1] / 2 - 0.5);
      }
    }

    const priceWrapper = container.querySelector('.price-wrapper-inner strong');
    const oldPriceWrapper = container.querySelector('.price-wrapper-inner .old-price');

    // Dezimaltrennzeichen je nach Storefront-Sprache (de = Komma)
    const isEnglishLocale = (document.documentElement.lang || '').toLowerCase().startsWith('en');
    const formatPriceCents = (cents) => {
      const s = `€${(cents / 100).toFixed(2)}`;
      return isEnglishLocale ? s : s.replace('.', ',');
    };

    if (priceWrapper) {
      priceWrapper.textContent = formatPriceCents(totalPrice);
    }

    if (oldPriceWrapper) {
      oldPriceWrapper.textContent = formatPriceCents(totalMainPrice);
    }
  }

  // Global change listener
  document.addEventListener('change', function (e) {

    // =========================
    // Price update
    // =========================
    if (e.target.matches('select[data-product-price]')) {

      const option = e.target.closest('.discount-option');

      if (option) {
        updatePrice(option);
      }
    }

    // =========================
    // Default variant update
    // =========================
    if (e.target.matches('.variant-option-cls select')) {

      const defaultHiddenVariant = document.querySelector('.default_variant_id');

      if (defaultHiddenVariant) {
        defaultHiddenVariant.value = e.target.value;
      }
    }

    // =========================
    // Quantity selector variant
    // =========================
    if (e.target.matches('.qauntiy-selector-wrapper .variant-dropdown')) {

      const wrapper = e.target.closest('.qauntiy-selector-wrapper');
      const hiddenVariant = wrapper?.querySelector('.custom_variant_id');

      if (hiddenVariant) {
        hiddenVariant.value = e.target.value;
      }
    }

    // =========================
    // Discount option radio
    // =========================
    if (e.target.matches('.custom-discount-options .discount-option input')) {

      document.querySelectorAll('.custom-discount-options .discount-option')
        .forEach(el => el.classList.remove('active'));

      const currentOption = e.target.closest('.discount-option');

      if (currentOption) {
        currentOption.classList.add('active');
      }

      const selectedValue = e.target.value;

      const container = e.target.closest('form, .product-container, .product-form');

      const quantityInput = container?.querySelector('.quantity-selector__input');

      if (quantityInput) {

        quantityInput.value = selectedValue;

        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));

        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        const inputWrapper =
          quantityInput.closest('[is="input-number"]') || quantityInput;

        inputWrapper.dispatchEvent(new Event('change', { bubbles: true }));

        inputWrapper.dispatchEvent(
          new CustomEvent('quantity-change', {
            detail: {
              quantity: Number(selectedValue)
            },
            bubbles: true
          })
        );
      }
    }
  });

});
document.addEventListener('click', function(e) {
  var sticky_btn = e.target.closest('#StickyAddToCart');
  if (sticky_btn) {
    e.preventDefault();
   const section = document.querySelector('.custom-discount-options');

// Scroll it into view smoothly
section.scrollIntoView({ 
  behavior: 'smooth', 
  block: 'start' 
});
  }
});